import React, { useEffect, useState } from 'react';
import DocumentTitle from 'react-document-title';
import SparklerLogo from '../../assets/images/sparkler-logo.svg';
import { Link } from 'react-router-dom';
import { appNamedRoutes } from '../routes';
import { withRouter } from 'react-router-dom';
import { Error } from '../components/Error';
import { parse } from 'query-string';
import PropTypes from 'prop-types';
import { AUTH_RECEIVE } from '../actions';
import { connect } from 'react-redux';
import { camelizeKeys } from 'humps';

const SingleSignOn = ({ location, history, match, authSuccess }) => {
  const [errorOpened, setErrorOpened] = useState(false);
  const [workEmail, setWorkEmail] = useState('');
  const [checked, setChecked] = useState(false);
  const { partner_id } = match.params;
  const refForm = React.createRef();
  const refEmail = React.createRef();

  useEffect(() => {
    const query = parse(location.search);
    if (query.error) {
      setErrorOpened(true);
      history.replace({ pathname: location.pathname, search: null });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const query = parse(location.search);
    if (query.email) {
      setWorkEmail(query.email);
      setChecked(true);
      refEmail.current.value = query.email;
      refForm.current.submit();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const query = parse(location.search);
    if (query.success) {
      authSuccess(camelizeKeys(JSON.parse(atob(query.success))));
      history.push({ pathname: '/dashboard', search: null });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refEmail.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DocumentTitle title='Sparkler'>
      <div className="cs-bg--sp-black o-login__wrap">
        <form ref={refForm} method='post' className="row o-login align-middle" action={`/partners/${partner_id}/saml/init`}>
          <input type="hidden" name="authenticity_token" value={document.querySelector('meta[name="csrf-token"]').content} />
          <div className="o-login__input o-login__logo u-margin-bottom--base">
            <Link to={appNamedRoutes.sso}>
              <img alt='' src={SparklerLogo} />
            </Link>
          </div>
          <div className="o-login__input">
            {errorOpened && (<Error
              message="Authentication failed. Please try again."
              status={errorOpened}
              messageType='alert'
              resetErrorMessage={() => {
                setErrorOpened(false);
              }}
            />)}
          </div>
          <div className="o-login__input">
            <input
              autoFocus
              ref={refEmail}
              name='email'
              autoCapitalize="none"
              type="email"
              placeholder="Work email"
              value={workEmail}
              onChange={(e) => {
                setWorkEmail(e.target.value);
                history.replace({ pathname: location.pathname, search: `?email=${e.target.value}` })
              }}
            />
          </div>
          <div className="o-login__input o-login__paragraph_checkbox">
            <input
              type="checkbox"
              name="sp-login-accept-privacy"
              id="sp-login-accept-privacy"
              onChange={() => setChecked(!checked)}
              checked={checked}
            />
            <label className="cs-txt--light o-login__input--label" htmlFor="sp-login-accept-privacy">
              By continuing, I affirm my commitment to privacy and security.
              <br />
              {'I agree to Sparkler\'s'} <a href="https://playsparkler.org/content/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> and <a href="https://playsparkler.org/content/terms-service" target="_blank" rel="noreferrer">Terms of Service</a>.
            </label>
          </div>
          <div className="o-login__input u-flex u-flex-gap u-flex-center u-flex-column">
            <button type="submit" disabled={!workEmail || !checked} className="o-sp-button o-sp-button--primary o-sp-button--login o-sp-button--block">
              Login
            </button>
          </div>
          <div className="o-login__input u-margin-top--base">
            <hr className="u-margin-bottom--small" />
            <Link to={appNamedRoutes.login} className="cs-txt-link--light u-float--right">Password login</Link>
          </div>
        </form>
      </div>
    </DocumentTitle >
  );
}

SingleSignOn.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  authSuccess: PropTypes.func,
  match: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => {
  return {
    authSuccess: (payload) => {
      dispatch({ type: AUTH_RECEIVE, payload });
    },
  }
}

export default withRouter(connect(null, mapDispatchToProps)(SingleSignOn));

